import { render, staticRenderFns } from "./ModalConjunto.vue?vue&type=template&id=16e4a9de&scoped=true&"
import script from "./ModalConjunto.vue?vue&type=script&lang=js&"
export * from "./ModalConjunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4a9de",
  null
  
)

export default component.exports